import React, { useState } from "react";

const IncrementButton = React.memo(({ onClick }) => {
  console.log("BUTTON RENDER");
  return (
    <button
      onClick={onClick}
      className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
    >
      Increment
    </button>
  );
});

function Test() {
  const [count, setCount] = useState(0);
  console.log("TEST RENDER");

  const handleClick = () => {
    setCount((prev) => prev + 1);
  };

  return (
    <div className="p-4">
      <div>Count: {count}</div>
      <IncrementButton onClick={handleClick} />
    </div>
  );
}

export default Test;
